import trackDefault from './utils/trackDefault';

const EVENT = 'share_button.clicked';

export default trackDefault(EVENT);
